import { MutationTree } from 'vuex';
import { EThresholdMutation } from './threshold.constants';
import { IThresholdState } from './threshold.types';

export const mutations: MutationTree<IThresholdState> = {
  [EThresholdMutation.SetShowActiveDocumentThresholdModal](state: IThresholdState, show: boolean) {
    state.showActiveDocumentThresholdModal = show;
  },
  [EThresholdMutation.SetActiveDocumentThreshold](
    state: IThresholdState,
    threshold: { documentCount: number; documentThreshold: number }
  ) {
    state.activeDocumentThreshold = threshold;
  },
  [EThresholdMutation.SetHasReachedActiveDocumentThreshold](
    state: IThresholdState,
    hasReachedThreshold: boolean
  ) {
    state.hasReachedActiveDocumentThreshold = hasReachedThreshold;
  },
  [EThresholdMutation.SetShowActiveDocumentThresholdPromptBar](
    state: IThresholdState,
    show: boolean
  ) {
    state.showActiveDocumentThresholdPromptBar = show;
  },
  [EThresholdMutation.SetDismissedActiveDocumentThresholdPromptBar](
    state: IThresholdState,
    dismissed: boolean
  ) {
    state.dismissedActiveDocumentThresholdPromptBar = dismissed;
  },
  [EThresholdMutation.SetState](state: IThresholdState, newState: IThresholdState) {
    state.activeDocumentThreshold = newState.activeDocumentThreshold;
    state.dismissedActiveDocumentThresholdPromptBar =
      newState.dismissedActiveDocumentThresholdPromptBar;
    state.hasReachedActiveDocumentThreshold = newState.hasReachedActiveDocumentThreshold;
    state.showActiveDocumentThresholdModal = newState.showActiveDocumentThresholdModal;
    state.showActiveDocumentThresholdPromptBar = newState.showActiveDocumentThresholdPromptBar;
  },
};
